import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import MarketingLayout from "@/components/MarketingLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import { ServicesIndex, ServiceDetail } from "@/pages/Services";
import Team from "@/pages/Team";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import Book from "@/pages/Book";
import { CalculatorsIndex, SIPCalculator, EMICalculator, RetirementCalculator, GoalCalculator, TaxCalculator } from "@/pages/Calculators";
import { InsightsIndex, InsightDetail } from "@/pages/Insights";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import PortalLayout, { PortalDashboard, PortalPortfolio, PortalDocuments, PortalAppointments, PortalProfile } from "@/pages/Portal";
import AdminLayout, { AdminOverview, AdminLeads, AdminAppointments, AdminClients, AdminBlog, AdminCareers, AdminNewsletter } from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<ServicesIndex />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/book" element={<Book />} />
              <Route path="/calculators" element={<CalculatorsIndex />} />
              <Route path="/calculators/sip" element={<SIPCalculator />} />
              <Route path="/calculators/emi" element={<EMICalculator />} />
              <Route path="/calculators/retirement" element={<RetirementCalculator />} />
              <Route path="/calculators/goal" element={<GoalCalculator />} />
              <Route path="/calculators/tax" element={<TaxCalculator />} />
              <Route path="/insights" element={<InsightsIndex />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
            </Route>

            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route path="/portal" element={<ProtectedRoute roles={["client"]}><PortalLayout /></ProtectedRoute>}>
              <Route index element={<PortalDashboard />} />
              <Route path="portfolio" element={<PortalPortfolio />} />
              <Route path="documents" element={<PortalDocuments />} />
              <Route path="appointments" element={<PortalAppointments />} />
              <Route path="profile" element={<PortalProfile />} />
            </Route>

            <Route path="/admin" element={<ProtectedRoute roles={["admin", "advisor"]}><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminOverview />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="appointments" element={<AdminAppointments />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="careers" element={<AdminCareers />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
